import EditKioskModal from './lib/Edit/EditKioskModal';
import NewKioskModal from './lib/New/NewKioskModal';

const KioskModal = ({ isOpen, handleClose, item, tableData }) => {
  return (
    <>
      {!item ? (
        <>
          <NewKioskModal
            isOpen={isOpen}
            handleClose={handleClose}
            kioskNr={(tableData?.length || 0) + 1}
            kiosks={tableData}
          />
        </>
      ) : (
        <EditKioskModal kiosk={item} setKiosk={handleClose} />
      )}
    </>
  );
};

export default KioskModal;
